<template>
  <div class="outer-container">
    <div class="ucontainer">
      <h2 class="heading_fonts text-center pb-5">
        Our Previous Clients
      </h2>
      <div class="grid">
        <div class="ch1">
          <img
            src="../../../assets/homeV2/Recruiter/lg_full_color_IM_4x 1.png"
            alt=""
          />

          <p class="pt-3">
            Used our Bootcamp Intensive ISA for <br />
            Hiring Data Science Expert.
          </p>
        </div>
        <div class="ch2">
          <img src="../../../assets/homeV2/Recruiter/1471107378.png" alt="" />

          <p class="pt-3">
            Bongo is currently doing Mini <br />
            boot camp for Hiring UIUX Expert
          </p>
        </div>
        <div class="ch4">
          <img src="../../../assets/lcp/lcp_logo.png" alt="" />

          <p class="pt-3">
            Used our Intensive Bootcamp for <br />
            hiring Front-End Developer
          </p>
        </div>
        <div class="ch3">
          <img
            src="../../../assets/homeV2/Recruiter/Image from iOS (5) 3.png"
            alt=""
          />

          <p class="pt-3">
            Used Our Assessment Test ISA <br />
            Program for hiring SEO - Executive
          </p>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {}
</script>

<style scoped>
.heading_fonts {
  font: 800 2.1rem/2.3rem 'Manrope';
  letter-spacing: -2%;
  color: #29292b;
}
.outer-container {
  background-color: white;
  padding: 130px 0;
}
.grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(250px, 1fr));
}
.grid > * h3 {
  color: #5439f7;
}

@media (max-width: 767.98px) {
  .grid {
    place-items: center;
  }
}
</style>
